import { render, staticRenderFns } from "./RTypePlaceEditor.vue?vue&type=template&id=588e419a&scoped=true&"
import script from "./RTypePlaceEditor.vue?vue&type=script&lang=js&"
export * from "./RTypePlaceEditor.vue?vue&type=script&lang=js&"
import style0 from "./RTypePlaceEditor.vue?vue&type=style&index=0&id=588e419a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e419a",
  null
  
)

/* custom blocks */
import block0 from "./RTypePlaceEditor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588e419a')) {
      api.createRecord('588e419a', component.options)
    } else {
      api.reload('588e419a', component.options)
    }
    module.hot.accept("./RTypePlaceEditor.vue?vue&type=template&id=588e419a&scoped=true&", function () {
      api.rerender('588e419a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypePlaces/RTypePlaceEditor.vue"
export default component.exports